module.exports = __webpack_public_path__ + "static/media/meal-plans-brands.d1d09e12.svg";